import { Address } from '@weave/schema-gen-ts/dist/schemas/phone/address/v1/address_service.pb';
import { http } from '@frontend/fetch';

export type E911AddressDisplayFields = {
  street?: string;
  streetSecondary?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
};

const normalizeAddressValue = (value?: string) =>
  value
    ?.trim()
    .toLowerCase()
    .replace(/\p{P}+$/gu, '')
    .trim() ?? '';

export const findMatchingE911Address = (addresses: Address[], address: E911AddressDisplayFields, addressId?: string) =>
  addresses.find(
    (existingAddress) =>
      existingAddress.id !== addressId &&
      normalizeAddressValue(existingAddress.street) === normalizeAddressValue(address.street) &&
      normalizeAddressValue(existingAddress.streetSecondary) === normalizeAddressValue(address.streetSecondary) &&
      normalizeAddressValue(existingAddress.city) === normalizeAddressValue(address.city) &&
      normalizeAddressValue(existingAddress.state) === normalizeAddressValue(address.state) &&
      normalizeAddressValue(existingAddress.postalCode) === normalizeAddressValue(address.postalCode) &&
      normalizeAddressValue(existingAddress.country) === normalizeAddressValue(address.country)
  );

export const formatE911AddressForDisplay = (address: E911AddressDisplayFields) =>
  `${address.street ?? ''}, ${address.streetSecondary ? `${address.streetSecondary}, ` : ''}${address.city ?? ''}, ${
    address.state ?? ''
  } ${address.postalCode ?? ''}, ${address.country ?? ''}`;

// Extracts the raw `cause` from the backend's nested E911 error response, if present.
const getE911AddressErrorCause = (error: unknown): string | undefined => {
  if (!http.isHttpError(error) || typeof error.data !== 'object' || error.data === null) return undefined;

  const rawMessage = (error.data as { message?: unknown }).message;
  if (typeof rawMessage !== 'string') return undefined;

  try {
    const parsedMessage = JSON.parse(rawMessage) as { cause?: unknown };
    return typeof parsedMessage.cause === 'string' ? parsedMessage.cause : undefined;
  } catch {
    return undefined;
  }
};

const isInvalidE911AddressCause = (cause: string | undefined) =>
  cause?.trim().toLowerCase() === 'invalid address for location';

export const isInvalidE911AddressError = (error: unknown) => isInvalidE911AddressCause(getE911AddressErrorCause(error));
